import axios, { AxiosInstance } from "axios";
import { auth } from "../config/firebase";
// import { ErrorMsg } from "../data/texts";

const BASE_URL = import.meta.env.VITE_BACKEND_URL;

class AxiosService {
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = axios.create({
      baseURL: BASE_URL,
    });

    this.axiosInstance.interceptors.request.use(async (config) => {
      const token = await auth.currentUser?.getIdToken();
      // if (!token) {
      //   throw new Error(ErrorMsg.UNAUTHENTICATED);
      // }
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    });
  }

  async get<T>(endpoint: string, formDataHeader?: boolean): Promise<T> {
    return this.axiosInstance
      .get(endpoint, {
        headers: this.getHeaders(formDataHeader),
      })
      .then((res) => res.data);
  }

  async post<T>(
    endpoint: string,
    body: any,
    formDataHeader?: boolean
  ): Promise<T> {
    return this.axiosInstance
      .post(endpoint, body, { headers: this.getHeaders(formDataHeader) })
      .then((res) => res.data);
  }

  async put<T>(
    endpoint: string,
    body: any,
    formDataHeader?: boolean
  ): Promise<T> {
    return this.axiosInstance
      .put(endpoint, body, { headers: this.getHeaders(formDataHeader) })
      .then((res) => res.data);
  }

  async patch<T>(
    endpoint: string,
    body: any,
    formDataHeader?: boolean
  ): Promise<T> {
    return this.axiosInstance
      .patch(endpoint, body, { headers: this.getHeaders(formDataHeader) })
      .then((res) => res.data);
  }

  async delete<T>(endpoint: string, formDataHeader?: boolean): Promise<T> {
    return this.axiosInstance
      .delete(endpoint, { headers: this.getHeaders(formDataHeader) })
      .then((res) => res.data);
  }

  getHeaders(formDataHeader?: boolean) {
    return formDataHeader
      ? { "content-type": "multipart/form-data" }
      : { "content-type": "application/json" };
  }
}

export const axiosService = new AxiosService();
